import { render, staticRenderFns } from "./addPeople.vue?vue&type=template&id=b5145a06&scoped=true"
import script from "./addPeople.vue?vue&type=script&lang=js"
export * from "./addPeople.vue?vue&type=script&lang=js"
import style0 from "./addPeople.vue?vue&type=style&index=0&id=b5145a06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5145a06",
  null
  
)

export default component.exports